import { render, staticRenderFns } from "./feedback-box.vue?vue&type=template&id=1fc29a3e&scoped=true"
import script from "./feedback-box.vue?vue&type=script&lang=js"
export * from "./feedback-box.vue?vue&type=script&lang=js"
import style0 from "./feedback-box.vue?vue&type=style&index=0&id=1fc29a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc29a3e",
  null
  
)

export default component.exports